import type { DadataSuggestion } from "@/stores/ContractorDetailStore/legal-store/LegalDataSubStore";
import { mdiMagnify } from "@mdi/js";
import Icon from "@mdi/react";

export function SuggestionDropdown({
  suggestions,
  onSelect,
  visible,
}: {
  suggestions: DadataSuggestion[];
  onSelect: (s: DadataSuggestion) => void;
  visible: boolean;
}) {
  if (!visible || suggestions.length === 0) return null;
  return (
    <div className="scd-drawer-suggestions">
      {suggestions.map((s, i) => (
        <button
          key={i}
          type="button"
          className="scd-drawer-suggestion"
          onMouseDown={(e) => {
            e.preventDefault();
            onSelect(s);
          }}
        >
          <Icon
            path={mdiMagnify}
            size={0.6}
            className="scd-drawer-suggestion__icon"
          />
          <span>{s.value}</span>
        </button>
      ))}
    </div>
  );
}
